// extracted by mini-css-extract-plugin
export default {"grid":"Failure_grid__B5wzY"};